'use strict';

/**
 * List of all objects on the rfid scanners
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ListLayout = require('./list');
var EmptyScannersView = require('modules/collection/views/partials/list-scanners-empty');
var HeaderView = require('./scanners-header');

var ScannerObjectListLayout = ListLayout.extend({
    getHeaderViewClass: function () {
        return HeaderView;
    },

    getEmptyViewClass: function() {
        return EmptyScannersView;
    },
});

module.exports = ScannerObjectListLayout;